import { PDFHeaderV2 } from "./PDFHeader";
import { PDF_COLORS, lineLayoutsV2 } from "./stylesPDFv2";

/**
 * Bloque de Pagaré (diseño moderno). Misma lógica/condiciones que el clásico:
 *  - versión larga (con salto de página + encabezado + caja "BUENO POR"),
 *  - versión corta (solo texto + firma).
 * La plantilla decide cuándo invocarlo (values.imprimirPagare && values.textoPagare).
 *
 * @param {object} params
 * @param {object} params.empresa
 * @param {Array<{label,value}>} params.meta filas de metadata del encabezado del pagaré
 * @param {string} params.buenoPor total formateado (texto)
 * @param {string} params.texto texto del pagaré
 * @param {boolean} params.pagareCorto
 * @returns Array de nodos pdfMake
 */
export const PDFPagareV2 = ({
  empresa = {},
  meta = [],
  buenoPor = "",
  texto = "",
  pagareCorto = false,
} = {}) => {
  const out = [];

  if (!pagareCorto) {
    out.push(
      { text: "", pageBreak: "after" },
      PDFHeaderV2({ empresa, regimenFiscal: false, tipoComprobante: false, meta }),
      {
        style: "tableExample",
        table: {
          widths: ["50%", "20%", "30%"],
          body: [
            [
              {
                text: "PAGARÉ",
                style: "tituloPagare",
                alignment: "left",
                border: [false, false, false, true],
              },
              {
                text: "BUENO POR:",
                style: "tituloPagare",
                alignment: "right",
                border: [false, false, false, true],
              },
              {
                text: buenoPor,
                style: "tituloPagare",
                alignment: "center",
                border: [false, false, false, true],
              },
            ],
          ],
        },
        layout: {
          ...lineLayoutsV2.seccion,
          hLineColor: () => PDF_COLORS.lineStrong,
        },
      }
    );
  }

  out.push({
    style: "tableExample",
    table: {
      widths: ["100%"],
      body: [
        [
          {
            text: texto + "\n\n",
            style: "textoPagare",
            alignment: "justify",
            border: [false, false, false, false],
          },
        ],
        [
          {
            text: "_______________________________________",
            style: "textoPagareFirma",
            alignment: "right",
            border: [false, false, false, false],
          },
        ],
        [
          {
            text: "FIRMA",
            style: "textoPagareFirma",
            alignment: "right",
            margin: [0, 0, 55, 0],
            border: [false, false, false, false],
          },
        ],
      ],
    },
    layout: lineLayoutsV2.noBorders,
  });

  return out;
};

export default PDFPagareV2;
